// Drapeau du pays d'origine d'un labo : SVG de flag-icons (MIT), copiés au build dans
// public/flags (scripts/copy-flags.mjs), pour n'importe quel pays. Pas d'émoji : Windows
// n'affiche pas les émojis de drapeau, seulement les lettres « FR », « CN ». Avec `label`,
// une image nommée ; sans, elle est décorative (le texte voisin nomme déjà le pays).
import type { Country } from "../pages/labs";

// Pays inconnu (labo pas encore situé, développeur indépendant) : un globe neutre aux couleurs
// du thème (public/flag-unknown.svg), jamais un pays deviné.
export default function Flag({ country, label }: { country?: Country; label?: string }) {
  const code = country?.toLowerCase();
  const known = !!code && /^[a-z]{2}$/.test(code);
  const name = known ? label : "Country not known yet";
  return (
    <img
      className="flag" src={known ? `/flags/${code}.svg` : "/flag-unknown.svg"} width={16} height={12} loading="lazy" decoding="async"
      alt={name ?? ""} title={name} {...(name ? {} : { "aria-hidden": true })}
    />
  );
}
